import { Moment } from 'moment';
import moment from 'moment';

export class Disclaimer {
  public id: string;
  public title: string;
  public text: string;
  public acknowledgementText: string;
  public isAcknowledged: boolean;
  public hasDownloadableFile: boolean;
  public fileName?: string;
  public activeStartDate?: Moment;
  public activeEndDate?: Moment;
  public updatedBy?: string;
  public createdBy?: string;
  public createdOn?: Date;
  public updatedOn?: Date;

  constructor(
    id: string,
    title: string,
    text: string,
    acknowledgementText: string,
    hasDownloadableFile: boolean,
    fileName: string,
    activeStartDate: Moment = null,
    activeEndDate: Moment = null,
    updatedBy: string,
    createdBy: string,
    createdOn: Date,
    updatedOn: Date
  ) {
    this.id = id;
    this.title = title;
    this.text = text;
    this.acknowledgementText = acknowledgementText;
    this.hasDownloadableFile = hasDownloadableFile;
    this.fileName = fileName;
    this.activeStartDate = activeStartDate;
    this.activeEndDate = activeEndDate;
    this.updatedBy = updatedBy;
    this.createdBy = createdBy;
    this.createdOn = createdOn;
    this.updatedOn = updatedOn;
  }

  static parse(obj: any): Disclaimer {
    const tempStart = moment(obj.activeStartDate, 'YYYY-MM-DDTHH:mm:ss.SS[Z]', false);
    const tempEnd = obj.activeEndDate
      ? moment(obj.activeEndDate, 'YYYY-MM-DDTHH:mm:ss.SS[Z]', false)
      : null;
    return new Disclaimer(
      obj.id,
      obj.title,
      obj.text,
      obj.acknowledgementText,
      obj.hasDownloadableFile,
      obj.fileName,
      tempStart,
      tempEnd,
      obj.updatedBy,
      obj.createdBy,
      obj.createdOn,
      obj.updatedOn
    );
  }
}
